<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14cx6nk/tc-custom/9780310452591.jpg?1736425248246" alt="This image is the cover for the book Generous Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Generous Life
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"Does my life make a difference?" People of all ages and stages of life want to live a life that has meaning and extends beyond their years on earth. In <i>A Generous Life</i>, Hobby Lobby founder David Green suggests readers start now to adopt a lifestyle of generosity.</b></p><p>As the founder and CEO of the largest privately owned arts and crafts retailer in the world, David has amassed material wealth, yet has learned the secret of generous living. As someone who gives away half of his profits to charity, lives with integrity and faith, and enjoys the peace of crafting a legacy now, David has found peace and fulfillment.</p><p><i>A Generous Life</i>:</p>guides you through ten simple but life-changing action stepshelps you establish a generous mindset, determine where and how much to give, how to create a family legacy plan, and moreteaches you how to identify your blessings—friendships, family, work, education, or talents<p>This beautiful hardcover book has a ribbon marker and a section for you to personalize a family legacy plan of your own. <i>A Generous Life</i> is a thoughtful gift for:</p>Christians looking for ways to connect with their purpose and faithhousewarming parties, baby showers for new parents, or college graduatesfans of Hobby Lobby and founder David<p>With practical helps on everything from deciding what you want your legacy to be to talking about money with your children, <i>A Generous Life </i>helps you start right where you are. You are richer than you know—and when you give it back to our generous God, your true wealth will never end.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David  Green, Bill High
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?dd6ec0f8